import styles from './SliderItem.module.scss';
import { Heading, RichText } from 'ui/components';
import { Picture } from 'ui/components/1-atoms/Media/Picture';

export interface SliderItemProps {
	heading?: string;
	text?: string;
	image?: Umbraco.Image;
	imageCaption?: string;
	imageAspectRatio?: number;
}

export const SliderItem: React.FC<SliderItemProps> = ({ heading, text, image, imageCaption, imageAspectRatio }) => {
	return (
		<div className={styles.SliderItem}>
			{heading && <Heading headingLevel="h3">{heading}</Heading>}
			{text && <RichText content={text} />}
			{image && !imageCaption && (
				<div className={styles.SliderItem_image}>
					<Picture
						url={image?.url}
						lazyload
						properties={image?.properties}
						aspectRatio={imageAspectRatio}
						className={styles.SliderItem_image}
					/>
				</div>
			)}
			{imageCaption && image && (
				<figure className={styles.SliderItem_figure}>
					{image && (
						<Picture
							url={image?.url}
							lazyload
							properties={image?.properties}
							aspectRatio={imageAspectRatio}
							className={styles.SliderItem_image}
						/>
					)}
					{imageCaption && <figcaption className={styles.SliderItem_caption}>{imageCaption}</figcaption>}
				</figure>
			)}
		</div>
	);
};
